import './assets/styles/main.css';
import './assets/styles/forms.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';

import App from './App.vue';
import router from './router';

import { Amplify } from 'aws-amplify';

Amplify.configure({
    Auth: {
        Cognito: {
            region: import.meta.env.VITE_AWS_REGION,
            userPoolId: import.meta.env.VITE_COGNITO_USER_POOP_ID,
            userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
            identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
            loginWith: {
                oauth: {
                    domain: '',
                    redirectSignIn: [],
                    redirectSignOut: [],
                    responseType: '',
                    scope: []
                },
                username: true,
                email: false,
                phone: false
            },
            allowGuestAccess: true
        }
    }
});

// Hotjar setup (always light mode only)

const app = createApp(App);

app.use(createPinia());
app.use(createHead());
app.use(router);

//
//  Load and initialize Sentry only in production.
//
async function loadSentry() {
    if (import.meta.env.PROD) {
        let mod = await import('@sentry/vue');
        mod.init({
            app: app,
            dsn: 'https://47944f4a6aa12014456a54f0525b3d79@o4509598565007360.ingest.us.sentry.io/4509598569070592',
            sendDefaultPii: true,
            integrations: [
                mod.browserTracingIntegration({ router: router }),
                mod.replayIntegration()
            ],
            tracesSampleRate: 1.0,
            tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0
        });
    }
}

loadSentry();

// Mount the app only after the router is ready
router.isReady().then(async () => {
    app.mount('#app');

    //  Get lower cased user agent
    let agent = navigator.userAgent.toLowerCase();

    if (
        !agent.includes('lighthouse') &&
        !agent.includes('speed insights') &&
        !agent.includes('googlebot')
    ) {
        let { default: Hotjar } = await import('@hotjar/browser');
        Hotjar.init(6452253, 6);

        // Initialize Google Ads tracking (loads asynchronously when user interacts)
        let { initializeGoogleAds } = await import('./utils/google-ads.js');
        initializeGoogleAds();
    }
});
